import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="15" height="710" viewBox="0 0 15 710" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" {...props}><path d="M13.31 708.43C9.26 435 4.61 171.86 1 7.89m6.74 685.78C1.33 474.24-.69 236.81 9.29 1" stroke="#000" strokeWidth="2" strokeLinecap="round" /></svg>);